export enum RegistratorCopyTypeEnum {
    VARIABLE_SETTINGS = 'variable_settings',
    VARIABLE_NAME = 'variable_name',
    LOGIC_EVENTS = 'logic_events',
    DEVICE_SETTINGS = 'device_settings',
    REPORTS = 'reports'
}

